// 困难生认定
export default [
    {
        path: '/nationalGrants',
        component: resolve => require(['@/pages/difficultStudent/difficultStudent.vue'], resolve),
        name: 'difficultStudent',
        meta: {
            title: '国家助学金'
        }
    },
    {
        path: '/nationalGrants/detail',
        component: resolve => require(['@/pages/difficultStudent/dsDetail.vue'], resolve),
        name: 'dsDetail',
        meta: {
            title: '国家助学金详情'
        }
    },
    {
        path: '/nationalGrants/detail/instructor',
        component: resolve => require(['@/pages/difficultStudent/dsDetail-instructor'], resolve),
        name: 'dsDetail-instructor',
        meta: {
            title: '国家助学金详情-辅导员'
        }
    },
    // {
    //     path: '/dsAdministration',
    //     component: resolve => require(['@/pages/difficultStudent/dsAdministration.vue'], resolve),
    //     name: 'dsAdministration',
    //     meta: {
    //         title: '困难生管理'
    //     }
    // },
    {
        path: '/dsStudentList',
        component: resolve => require(['@/pages/difficultStudent/ds-student-list'], resolve),
        name: 'dsStudentList',
        meta: {
            title: '查看名单'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/modules/nationalGrants.js